export const getCleanImage = (url) => {
    // Handle null/undefined explicitly, allow empty string
    if (url === null || url === undefined) {
        return undefined;
    }
    // Proceed even if url is an empty string
    const questionMarkIndex = url.indexOf("?");
    if (questionMarkIndex !== -1) {
        return url.substring(0, questionMarkIndex);
    }
    // Ensure this return exists
    return url;
};
